function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0082FF",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 6V17.59L12.17 13.75C12.69 12.96 13 12.02 13 11C13 8.24 10.76 6 8 6C5.24 6 3 8.24 3 11C3 13.76 5.24 16 8 16C9.02 16 9.96 15.69 10.76 15.17L15.19 19.6C14.85 19.85 14.45 20 14 20H1.99C0.89 20 0 19.1 0 18L0.01 2C0.01 0.9 0.9 0 2 0H10L16 6ZM8 14C6.34 14 5 12.66 5 11C5 9.34 6.34 8 8 8C9.66 8 11 9.34 11 11C11 12.66 9.66 14 8 14Z",
  fill: "white"
});

var SvgReviewIcon = function SvgReviewIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReviewIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ReviewIcon.7941570d.svg";
export { ForwardRef as ReactComponent };